<template>
  <b-container fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title">{{ $t('sales_center.stock_report') }}</h4>
      </template>
      <template v-slot:body>
        <b-overlay :show="unitLoad">
          <b-row>
            <b-col xs="12" sm="12" md="6" lg="6" xl="6">
              <b-form-group
                class="row"
                label-cols-sm="3"
                label-for="fiscal_year_id"
              >
                <template v-slot:label>
                  {{$t('globalTrans.fiscal_year')}} <span class="text-danger">*</span>
                </template>
                <b-form-select
                  plain
                  v-model="search.fiscal_year_id"
                  :options="fiscalYearList"
                  id="fiscal_year_id"
                  >
                  <template v-slot:first>
                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                  </template>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col xs="12" sm="12" md="6" lg="6" xl="6">
              <b-form-group
                class="row"
                label-cols-sm="3"
                label-for="month"
              >
                <template v-slot:label>
                  {{$t('production_store.month')}}
                </template>
                <b-form-select
                  plain
                  v-model="search.month"
                  :options="monthList"
                  id="month"
                  >
                  <template v-slot:first>
                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                  </template>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                <b-form-group
                 class="row"
                 label-cols-sm="3"
                 label-for="from_date"
                 >
                <template v-slot:label>
                {{$t('sales_distribution_admin.from_date')}}
                </template>
                <b-form-input class="form-control"
                 v-model="search.from_date"
                 placeholder="Select From Date"
                 id="from_date"
                 ></b-form-input>
                 </b-form-group>
            </b-col>
            <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                <b-form-group
                 class="row"
                 label-cols-sm="3"
                 label-for="to_date"
                 >
                <template v-slot:label>
                 {{$t('sales_distribution_admin.to_date')}}
                </template>
                <b-form-input class="form-control"
                 v-model="search.to_date"
                 placeholder="Select To Date"
                 id="to_date"
                 ></b-form-input>
                </b-form-group>
            </b-col>
            <b-col cols="12" class="text-right">
              <b-button type="button" variant="primary" @click="searchData">{{ $t('sales_distribution_admin.report')}}</b-button>
            </b-col>
          </b-row>
        </b-overlay>
      </template>
    </iq-card>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:body>
            <b-row v-if="loaded">
              <b-col xs="12" sm="12" md="3" class="text-right mt-3">
                <b-img :src="`${ reportHeadData.reportHeadColumn[0].image }`" fluid alt="BD Image" style="width:35%;border-radius:50%;"></b-img>
              </b-col>
              <b-col xs="12" sm="12" md="6" class="text-center mt-2">
                <h3 class="text-bold">{{ $t('production_store.govt_info') }}</h3>
                <h4 class="text-center text-dark">{{ reportHeadData.orgName }}</h4>
                <span class="text-center text-dark">{{ reportHeadData.heading }}</span><br>
                <span class="text-center text-dark">{{ reportHeadData.address }}</span><br>
                <div class="titleDiv">
                  <span class="text-center text-dark reportTitle" style="font-weight:bold;">{{ $t('sales_center.stock_report') }}</span><br>
                </div>
              </b-col>
              <b-col xs="12" sm="12" md="3" class="mt-4 text-right">
                <b-button-group>
                  <b-button @click="pdfExport" variant="success">{{  $t('globalTrans.export_pdf') }}</b-button>
                  <b-button variant="warning">
                    <export-excel
                      :data="excelData"
                      :title="headerValue"
                      worksheet="Report Sheet"
                      name="stock-report.xls">
                      {{ $t('globalTrans.export_excel') }}
                    </export-excel>
                  </b-button>
                </b-button-group>
              </b-col>
              <b-col xs="12" sm="12" md="12" class="mt-4 mb-1">
                <b-row>
                  <b-col xs="12" sm="12" md="8" class="text-left">
                    <span v-if="titleData.from_date == '' && titleData.to_date == '' && titleData.monthname !== ''" class="text-center text-dark">{{ ' ' + $t('sales_distribution_admin.month') + ' : ' }}{{ titleData.monthname }}</span>
                  </b-col>
                  <b-col xs="12" sm="12" md="4" class="text-right">
                    <span class="text-center text-dark">{{ titleData.year }}</span><br>
                    <span v-if="titleData.from_date !== '' || titleData.to_date !== ''" class="text-center text-dark">{{ ' ' + $t('globalTrans.date') + ' : ' }}</span>
                    <span v-if="titleData.from_date !== ''" class="text-center text-dark">{{ titleData.from_date | dateFormat }}</span>
                    <span v-if="titleData.from_date !== '' && titleData.to_date !== ''" class="text-center text-dark">{{ ' ' + $t('sales_distribution_admin.to') + ' ' }}</span>
                    <span v-if="titleData.to_date !== ''" class="text-center text-dark">{{ titleData.to_date | dateFormat }}</span>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-overlay :show="loadingState">
              <b-row>
                <b-col lg="12" xs="12" md="12">
                    <b-table bordered hover :items="report_data" :fields="columns" aria-hidden="loading | listReload ? 'true' : null" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                      <template v-slot:cell(index)="data">
                        {{ $n(data.index + 1) }}
                      </template>
                      <template v-slot:cell(pro_name)="data">
                        {{ getProductName(data.item) }}
                      </template>
                      <template v-slot:cell(unit_id)="data">
                        <span v-for="(item, idx) in getUnitName(data.item)" :key="idx">
                          <div>{{ item }}</div>
                        </span>
                      </template>
                      <template v-slot:cell(opening_stock)="data">
                        <span v-for="(item, idx) in getOpeningStock(data.item)" :key="idx">
                          <div>{{ $n(item) }}</div>
                        </span>
                      </template>
                      <template v-slot:cell(current_sales)="data">
                        <span v-for="(item, idx) in getCurrentSales(data.item)" :key="idx">
                          <div>{{ $n(item) }}</div>
                        </span>
                      </template>
                      <template v-slot:cell(current_stock)="data">
                        <span v-for="(item, idx) in getCurrentStock(data.item)" :key="idx">
                          <div>{{ $n(item) }}</div>
                        </span>
                      </template>
                      <template v-slot:cell(unit_price)="data">
                        <span v-for="(item, idx) in getUnitPrice(data.item)" :key="idx">
                          <div>{{ $n(item) }}</div>
                        </span>
                      </template>
                      <template v-slot:cell(total_price)="data">
                        <span v-for="(item, idx) in getTotalPrice(data.item)" :key="idx">
                          <div>{{ $n(item) }}</div>
                        </span>
                      </template>
                    </b-table>
                    <b-pagination
                      v-model="pagination.currentPage"
                      :per-page="pagination.perPage"
                      :total-rows="pagination.totalRows"
                      @input="searchData"
                    />
                </b-col>
              </b-row>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { mapGetters } from 'vuex'
import RestApi, { productionServiceBaseUrl, commonServiceBaseUrl } from '@/config/api_config'
import { fiscalYearData, stockReportApi } from '../../api/routes'
import RouteBasedList from '@/mixins/route-base-list'
import ExportPdf from './export-pdf_details'
import ReportHeading from '@/Utils/report-head'
import flatpickr from 'flatpickr'
import excel from 'vue-excel-export'
import Vue from 'vue'
Vue.use(excel)

export default {
  mixins: [RouteBasedList],
  data () {
    return {
      search: {
        sales_center_id: this.$store.state.Auth.authUser.office_id,
        month: 0,
        from_date: '',
        to_date: '',
        fis_start_date: '',
        fis_end_date: '',
        fiscal_year_id: 0
      },
      titleData: {
        monthname: '',
        year: '',
        from_date: '',
        to_date: ''
      },
      report_data: [],
      rows: [],
      nodata: true,
      reportHeadData: '',
      loaded: false,
      unitLoad: false
    }
  },
  computed: {
    headerValue: function () {
        const headerVal = []
        if (this.$i18n.locale === 'en') {
            headerVal[0] = this.reportHeadData.orgName
            headerVal[1] = this.reportHeadData.address
            headerVal[2] = this.$t('sales_center.stock_report')
            // headerVal[3] = this.getHeadParam()
        } else {
            headerVal[0] = this.reportHeadData.orgName
            headerVal[1] = this.reportHeadData.address
            headerVal[2] = this.$t('sales_center.stock_report')
            // headerVal[3] = this.getHeadParam()
        }
      const year = (this.titleData.year ? this.titleData.year : this.$t('globalTrans.all')) + ';' + ' ' + ' ' + ' ' + ' '
      const month = this.$t('sales_distribution_admin.month') + ' : ' + (this.titleData.monthname ? this.titleData.monthname : this.$t('globalTrans.all')) + ';' + ' ' + ' ' + ' ' + ' '
      const startDate = this.$t('sales_distribution_admin.from_date') + ' : ' + (this.titleData.start_date ? this.titleData.start_date : this.$t('globalTrans.all')) + ';' + ' ' + ' ' + ' ' + ' '
      const endDate = this.$t('sales_distribution_admin.to_date') + ' : ' + (this.titleData.to_date ? this.titleData.to_date : this.$t('globalTrans.all')) + ';' + ' ' + ' ' + ' ' + ' '
      headerVal[3] = year + month
      headerVal[4] = startDate + endDate
      return headerVal
    },
    excelData: function () {
        const listData = this.report_data
        var serial = 0
        const listContractor = listData.map(keyItem => {
            serial++
            if (this.$i18n.locale === 'en') {
                return {
                    'SL No': serial,
                    'Description ': this.getProductName(keyItem),
                    'Unit ': this.getUnitName(keyItem),
                    'Opening Stock': this.getOpeningStock(keyItem),
                    'Current Sales': this.getCurrentSales(keyItem),
                    'Current Stock': this.getCurrentStock(keyItem),
                    'Unit Price': this.getUnitPrice(keyItem),
                    'Total Price': this.getTotalPrice(keyItem)
                }
            } else {
            return {
                'ক্রমিক সংখ্যা': this.$n(serial),
                'বিবরণ ': this.getProductName(keyItem),
                'ইউনিট ': this.getUnitName(keyItem),
                'ওপেনিং স্টক': this.$n(this.getOpeningStock(keyItem)),
                'বর্তমান বিক্রয় ': this.$n(this.getCurrentSales(keyItem)),
                'বর্তমান প্রোডাকশন স্টক': this.$n(this.getCurrentStock(keyItem)),
                'একক দাম': this.$n(this.getUnitPrice(keyItem)),
                'মোট দাম': this.$n(this.getTotalPrice(keyItem))
            }
            }
        })
        return listContractor
    },
    fiscalYearList: function () {
      return this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0)
    },
    monthList () {
      const objectData = this.$store.state.commonObj.monthList
      return objectData.map((obj, key) => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.value, text: obj.text_bn }
        } else {
          return { value: obj.value, text: obj.text_en }
        }
      })
    },
    productList () {
      return this.productCommonObj.productList.filter(item => item.status === 1 && item.type_id === 2)
    },
    currentLocale () {
      return this.$i18n.locale
    },
    columns () {
      const labels = [
          { label: this.$t('globalTrans.sl_no'), class: 'text-left' },
          { label: this.$t('globalTrans.description'), class: 'text-left' },
          { label: this.$t('sales_distribution_admin.unit'), class: 'text-left' },
          { label: this.$t('sales_distribution_admin.opening_stock'), class: 'text-left' },
          { label: this.$t('sales_center.current_sales'), class: 'text-left' },
          { label: this.$t('sales_distribution_admin.current_stock'), class: 'text-left' },
          { label: this.$t('sales_distribution_admin.unit_price'), class: 'text-left' },
          { label: this.$t('sales_distribution_admin.total_price'), class: 'text-left' }
        ]

      let keys = []

      if (this.$i18n.locale === 'bn') {
        keys = [
          { key: 'index' },
          { key: 'pro_name' },
          { key: 'unit_id' },
          { key: 'opening_stock' },
          { key: 'current_sales' },
          { key: 'current_stock' },
          { key: 'unit_price' },
          { key: 'total_price' }
        ]
      } else {
        keys = [
          { key: 'index' },
          { key: 'pro_name' },
          { key: 'unit_id' },
          { key: 'opening_stock' },
          { key: 'current_sales' },
          { key: 'current_stock' },
          { key: 'unit_price' },
          { key: 'total_price' }
        ]
      }

      return labels.map((item, index) => {
          return Object.assign(item, keys[index])
        })
    },
    ...mapGetters({
      productCommonObj: 'ProductionService/commonObj'
    })
  },
  watch: {
    'search.from_date': function (newVal, oldVal) {
      if (newVal !== oldVal) {
          this.titleData.monthname = ''
          this.search.month = 0
          this.report_data = []
          this.titleData.from_date = this.search.from_date
      }
    },
    'search.to_date': function (newVal, oldVal) {
        this.titleData.monthname = ''
        this.search.month = 0
        this.report_data = []
        this.titleData.to_date = this.search.to_date
    },
    'search.fiscal_year_id': function (newVal, oldVal) {
      if (newVal !== 0) {
        this.unitLoad = true
        RestApi.getData(commonServiceBaseUrl, `${fiscalYearData}/${newVal}`).then(response => {
          this.search.fiscal_year_id = response.data.id
          this.search.fis_start_date = response.data.start_date
          this.search.fis_end_date = response.data.end_date
          this.titleData.year = this.getFiscalYear(response.data.id)
          this.report_data = []
          this.unitLoad = false
        })
      } else {
          this.search.fiscal_year_id = 0
          this.search.fis_start_date = ''
          this.search.fis_end_date = ''
          this.titleData.year = ''
          this.report_data = []
      }
    },
    'search.month': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.search.from_date = ''
        this.search.to_date = ''
        this.titleData.from_date = ''
        this.titleData.to_date = ''
        this.titleData.monthname = newVal !== 0 ? this.getMonthName(newVal) : ''
        this.report_data = []
      }
    },
     currentLocale: function (newVal, oldVal) {
        if (newVal !== oldVal) {
            }
            this.headerName()
            this.titleData.year = this.getFiscalYear(this.search.fiscal_year_id)
            this.titleData.to_date = (this.search.to_date)
            this.titleData.from_date = (this.search.from_date)
            this.titleData.monthname = this.getMonthName(this.search.month)
        }
  },
  created () {
    this.headerName()
  },
   mounted () {
        flatpickr('#to_date', {})
        flatpickr('#from_date', {})
  },
  methods: {
    // getHeadParam () {
    //     return (this.titleData.year ? this.titleData.year + ',' : '') +
    //        (this.titleData.monthname ? this.titleData.monthname + ',' : '') +
    //        (this.titleData.from_date ? this.titleData.from_date + ',' : '') +
    //        (this.titleData.to_date ? this.titleData.to_date : '')
    // },
    getFiscalYear (Id) {
        const Year = this.$store.state.commonObj.fiscalYearList.find(item => item.value === Id)
        if (this.$i18n.locale === 'bn') {
            return this.$t('globalTrans.fiscal_year') + ': ' + Year.text_bn
        } else {
            return this.$t('globalTrans.fiscal_year') + ': ' + Year.text_en
        }
    },
    getProductName (stockData) {
      let category = ''
      Object.keys(stockData).forEach((value) => {
        const catId = parseInt(value)
        const catObj = this.productList.find(item => item.value === catId)
        if (this.$i18n.locale === 'bn') {
          category = catObj.text_bn
        } else {
          category = catObj.text_en
        }
      })
      return category
    },
    getUnitName (prodData) {
      const unitName = []
      Object.entries(prodData).forEach(([key, value]) => {
        Object.keys(value).forEach((unvalue) => {
          const unitId = parseInt(unvalue)
          const unit = this.productCommonObj.unitInfoList.find(item => item.value === unitId)
          if (this.$i18n.locale === 'bn') {
            unitName.push(unit.text_bn)
          } else {
            unitName.push(unit.text_en)
          }
        })
      })
      return unitName
    },
    getCurrentStock (prodData) {
      const CurrentStock = []
      Object.entries(prodData).forEach(([key, value]) => {
        Object.entries(value).forEach(([key, kvalue]) => {
          CurrentStock.push(kvalue.stock_qty)
        })
      })
      return CurrentStock
    },
    getOpeningStock (prodData) {
      const CurrentStock = []
      Object.entries(prodData).forEach(([key, value]) => {
        Object.entries(value).forEach(([key, kvalue]) => {
          CurrentStock.push(kvalue.opening_quantity)
        })
      })
      return CurrentStock
    },
    getCurrentSales (prodData) {
      const CurrentStock = []
      Object.entries(prodData).forEach(([key, value]) => {
        Object.entries(value).forEach(([key, kvalue]) => {
          CurrentStock.push(kvalue.sales_qty)
        })
      })
      return CurrentStock
    },
    getUnitPrice (prodData) {
      const CurrentStock = []
      Object.entries(prodData).forEach(([key, value]) => {
        Object.entries(value).forEach(([key, kvalue]) => {
          CurrentStock.push(kvalue.unit_price)
        })
      })
      return CurrentStock
    },
    getTotalPrice (prodData) {
      const CurrentStock = []
      Object.entries(prodData).forEach(([key, value]) => {
        Object.entries(value).forEach(([key, kvalue]) => {
          const total = kvalue.unit_price * kvalue.stock_qty
          CurrentStock.push(total)
        })
      })
      return CurrentStock
    },
    getMonthName (mId) {
      const monthId = parseInt(mId)
      const monthObj = this.monthList.find(item => item.value === monthId)
      return monthObj.text
    },
    searchData () {
      this.loadData()
    },
    loadData () {
      const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
      this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      RestApi.getData(productionServiceBaseUrl, stockReportApi, params).then(response => {
          if (response.success) {
            this.report_data = response.data
            this.$store.dispatch('setList', response.data)
            this.paginationData(response.data)
          }
          this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
      })
    },
    async headerName () {
       const headdata = await ReportHeading.getReportHead(productionServiceBaseUrl, 'configuration/report-heading/detail', 6)
       this.reportHeadData = headdata
       this.loaded = true
    },
    pdfExport () {
      const reportTitle = this.$t('sales_center.stock_report')
      ExportPdf.exportPdfDetails(productionServiceBaseUrl, 'configuration/report-heading/detail', 6, reportTitle, JSON.parse(JSON.stringify(this.report_data)), this, this.titleData)
    }
  }
}
</script>
<style scoped>
.reportTitle {
  font-weight: bold;
    border: 1px solid;
    padding: 8px 15px 8px 15px;
    border-radius: 11px;
}
.titleDiv {
  margin-top: 1.5rem;
  font-size: 18px;
}
</style>
